export default {
	list: (state) => {
		return state.list
	},
	
	selection: (state) => {
		return state.selection
	}
}